import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../lib/analytics/tracking';
import { resumeEvents, timingEvents } from '../lib/analytics/events';
import type { StepId } from '../components/resume/ResumeBuilder/constants';

export function useResumeAnalytics(currentStep: StepId) {
  const location = useLocation();
  const stepStartTime = useRef(Date.now());
  const buildStartTime = useRef(Date.now());

  // Track step changes
  useEffect(() => {
    // Track step completion time
    const stepDuration = Date.now() - stepStartTime.current;
    trackEvent(timingEvents.stepDuration(currentStep, stepDuration));
    
    // Reset timer for new step
    stepStartTime.current = Date.now();
    
    // Track step completion
    trackEvent(resumeEvents.completeStep(currentStep));
  }, [currentStep]);

  // Track exit events
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Track total time spent
      const totalDuration = Date.now() - buildStartTime.current;
      trackEvent(timingEvents.totalDuration(totalDuration));
      
      // Track exit from current step
      trackEvent(resumeEvents.exitStep(currentStep));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [currentStep]);

  // Track navigation away
  useEffect(() => {
    return () => {
      if (!location.pathname.includes('/resume')) {
        // Track exit when navigating away
        trackEvent(resumeEvents.exitStep(currentStep));
      }
    };
  }, [location, currentStep]);
}